import React, { useEffect, useState } from "react";

//ANT DESIGN
import ImgCrop from "antd-img-crop";
import {
  LeftOutlined,
  UploadOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  UserOutlined,
  CameraOutlined,
} from "@ant-design/icons";
import {
  Button,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Select,
  Spin,
  Form,
  Descriptions,
  Divider,
  Flex,
  Tooltip,
  Upload,
  Avatar,
  Space,
  Image,
  Modal,
  message,
} from "antd";
import CustomerPic from "../../../../assets/images/empty-profile-picture.png";
import signature from "../../../../assets/images/signature.png";
import mockCustomers from "../../../../config/data/mockPeople.json";
import { Pie, measureTextWidth } from "@antv/g2plot";

//PROJECT IMPORTS
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import { handleFlgStatus } from "../../../../components/facilities/AccountFacility";
import styles from "../../../../assets/styles/styles";
import axios from "axios";
import appConfig from "../../../../config/appConfig";
import Cookies from "js-cookie";

const { Text } = Typography;

export default function CustomerInfo(props) {
  const { currentCustomerObj, session } = props;
  const [customerDetails, setCustomerDetails] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getDetailById();
  }, []);

  const getDetailById = () => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${currentCustomerObj.id}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setIsLoading(false);
        // setCustomerDetails(objDetail);
        setIsLoading(false);
      }
    });
  };

  return (
    <Card
      style={{
        marginBottom: 25,
        boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
        borderRadius: 20,
      }}
      title={
        <Row
          style={{
            alignContent: "center",
            width: "8%",
          }}
        >
          <Button
            icon={<LeftOutlined />}
            type="text"
            style={{
              marginTop: "auto",
              marginBottom: "auto",
            }}
            onClick={props.backOnClick}
          >
            <Text
              style={{ marginTop: "auto", marginBottom: "auto", fontSize: 15 }}
            >
              Back
            </Text>
          </Button>
        </Row>
      }
    >
      <Row>
        <Col span={10}>
          <CustomerDetailsCard
            customerDetails={currentCustomerObj}
            session={session}
            spinning={isLoading}
          />
        </Col>
        <Col span={7} style={{ padding: "0px 8px" }}>
          <AssetPositionCard />
        </Col>
        <Col span={7}>
          <LiabilityPositionCard />
        </Col>
      </Row>
    </Card>
  );
}

function CustomerDetailsCard(props) {
  const { customerDetails, session } = props;
  const [isShowSignature, setIsShowSignature] = useState(false);
  const [onEditShow, setOnEditShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [profileImageList, setProfileImageList] = useState([]);
  const [isUploadDisabled, setIsUploadDisabled] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [isProfileModalVisible, setIsProfileModalVisible] = useState(false);
  const [profileImageData, setProfileImageData] = useState(null);
  const [hasLoadedImage, setHasLoadedImage] = useState(false);
  const [isProfilePreviewVisible, setIsProfilePreviewVisible] = useState(false);
  const displayStatus = handleFlgStatus(customerDetails?.status?.value, {
    fontSize: 16,
  });
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (BOM.HasPermission("READ_DOCUMENT")) {
      getSignature();
      getProfileImage();
    }
  }, []);

  const getSignature = async () => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${customerDetails.id}/documents`;
    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, async (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = BOM.GetUnique(res, "name");
        const signature = objList.find(
          (item) => item.name?.toLowerCase() === "clientsignature",
        );
        if (signature) {
          const signatureImage = await getSignatureImage(signature);
          setFileList([
            {
              uid: signature.id,
              name: "image.png",
              status: "done",
              url: signatureImage,
            },
          ]);
        }
        setIsLoading(false);
      }
    });
  };

  const getProfileImage = () => {
    setIsLoading(true);

    const url = `${apiConfig.Clients}/${customerDetails.id}/images`;
    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        setHasLoadedImage(true);
      } else {
        try {
          if (res && res.length > 0) {
            if (typeof res === "string" && res.startsWith("data:image")) {
              setProfileImageData(res);
            } else if (
              Array.isArray(res) &&
              res[0] &&
              res[0].contentType &&
              res[0].contentType.includes("image")
            ) {
              const imageId = res[0].id;
              setProfileImageData({
                id: imageId,
                url: `${apiConfig.Clients}/${customerDetails.id}/images/${imageId}?tenantIdentifier=default`,
              });
            } else if (
              res[0] &&
              typeof res[0] === "string" &&
              res[0].startsWith("data:image")
            ) {
              setProfileImageData(res[0]);
            } else if (res && typeof res === "string") {
              if (isBase64(res)) {
                setProfileImageData(`data:image/jpeg;base64,${res}`);
              }
            }
          }
        } catch (error) {
          console.error("Error processing profile image:", error);
        }

        setHasLoadedImage(true);
        setIsLoading(false);
      }
    });
  };

  const isBase64 = (str) => {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const onProfileImageChange = ({ fileList: newFileList }) => {
    setProfileImageList(newFileList);
  };

  const handlePreview = async (file) => {
    console.log(file);

    if (!file?.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const showProfileModal = () => {
    setIsProfileModalVisible(true);
  };

  const handleProfileModalCancel = () => {
    setIsProfileModalVisible(false);
    setProfileImageList([]);
  };

  const handleProfileUpload = () => {
    if (profileImageList.length === 0) {
      message.warning("Please select an image first");
      return;
    }

    if (profileImageList[0]?.originFileObj) {
      uploadImageToServer(profileImageList[0].originFileObj);
    }
  };

  const uploadImageToServer = (fileBlob) => {
    if (!BOM.HasPermission("CREATE_CLIENTIMAGE")) {
      message.error("Insufficient privileges to upload profile image");
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append("file", fileBlob);

    fetch(`${apiConfig.Clients}/${customerDetails.id}/images`, {
      method: "POST",
      headers: {
        Authorization: session,
        "Finsys-Platform-Tenantid": "default",
      },
      body: formData,
    })
      .then(async (response) => {
        if (!response.ok) {
          let errorMessage = "Profile image upload failed";

          try {
            const errorData = await response.json();

            if (errorData.errors && errorData.errors.length > 0) {
              errorMessage =
                errorData.errors[0].defaultUserMessage ||
                errorData.defaultUserMessage;
            } else if (errorData.defaultUserMessage) {
              errorMessage = errorData.defaultUserMessage;
            }
          } catch (parseError) {
            const errorText = await response
              .text()
              .catch(() => "Unknown error");
            errorMessage = `Upload failed (${response.status}): ${errorText}`;
          }

          throw new Error(errorMessage);
        }
        return response.text();
      })
      .then((data) => {
        message.success("Profile image uploaded successfully");
        getProfileImage();
        setIsProfileModalVisible(false);
        setProfileImageList([]);
      })
      .catch((error) => {
        console.error("Upload error:", error);
        message.error(error.message, 5);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const handleDeleteProfileImage = () => {
    if (!BOM.HasPermission("DELETE_CLIENTIMAGE")) {
      message.error("Insufficient privileges to delete profile image");
      return;
    }

    Modal.confirm({
      title: "Are you sure you want to delete this profile image?",
      icon: <DeleteOutlined />,
      content: "This action cannot be undone.",
      okText: "Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk() {
        setIsLoading(true);

        const imageId = profileImageData?.id;
        const url = imageId
          ? `${apiConfig.Clients}/${customerDetails.id}/images/${imageId}`
          : `${apiConfig.Clients}/${customerDetails.id}/images`;

        fetch(url, {
          method: "DELETE",
          headers: {
            Authorization: session,
            "Finsys-Platform-Tenantid": "default",
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error("Failed to delete profile image");
            }
            message.success("Profile image deleted successfully");
            setProfileImageData(null);
          })
          .catch((error) => {
            message.error("Error deleting profile image: " + error.message);
          })
          .finally(() => {
            setIsLoading(false);
          });
      },
    });
  };

  const uploadProps = {
    listType: "picture-card",
    headers: {
      Authorization: session,
      "Finsys-Platform-Tenantid": "default",
    },
    accept: "image/*",
    onSuccess(ret) {
      getSignature();
    },
    onRemove(file) {
      if (!BOM.HasPermission("DELETE_DOCUMENT")) {
        BOM.AlertMsg(
          cnt.WARNING,
          "Insufficient privileges to delete Signature",
        );
        return false;
      }
      if (!BOM.HasPermission("CREATE_DOCUMENT")) {
        setIsUploadDisabled(true);
      }
      return true;
    },
  };

  const profileUploadProps = {
    listType: "picture-card",
    fileList: profileImageList,
    onChange: onProfileImageChange,
    onPreview: handlePreview,
    beforeUpload: (file) => {
      const isImage = file.type.startsWith("image/");
      if (!isImage) {
        message.error("You can only upload image files!");
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error("Image must be smaller than 2MB!");
        return false;
      }

      return false;
    },
    maxCount: 1,
  };

  const getSignatureImage = async (signature) => {
    try {
      const url = `${apiConfig.Clients}/${customerDetails.id}/documents/${signature.id}/attachment?tenantIdentifier=default`;

      const { headers } = appConfig.apiSettings;
      headers.Authorization = session;

      const tfaToken = Cookies.get("tfaToken");
      if (tfaToken && tfaToken !== "null" && tfaToken !== "undefined") {
        headers["Fineract-Platform-TFA-Token"] = tfaToken;
      } else {
        delete headers["Fineract-Platform-TFA-Token"];
      }

      const response = await axios({
        method: "GET",
        url: url,
        headers: headers,
        responseType: "blob",
      });

      const blob = new Blob([response.data]);
      const imageUrl = URL.createObjectURL(blob);

      setIsLoading(false);
      return imageUrl;
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };

  const renderUploadFram = (params) => {
    let endPoint = "documents";

    switch (params.key.toLowerCase()) {
      case "signature":
        break;
      case "profile":
        endPoint = "images";
        break;
      default:
        break;
    }

    const dataParam = {
      name: params.name,
      description: params.description,
    };

    return (
      <div
        style={{
          width: 100,
          marginRight: "auto",
          display: isShowSignature ? "" : "none",
        }}
      >
        <ImgCrop rotationSlider>
          <Upload
            {...uploadProps}
            action={`${apiConfig.Clients}/${customerDetails.id}/${endPoint}`}
            fileList={fileList}
            onChange={onChange}
            onPreview={handlePreview}
            data={dataParam}
            disabled={isUploadDisabled}
          >
            {!isUploadDisabled &&
              (fileList.length === 0 || onEditShow) &&
              "+ Upload"}
          </Upload>
        </ImgCrop>

        {previewImage && (
          <Image
            wrapperStyle={{
              display: "none",
            }}
            preview={{
              visible: previewOpen,
              onVisibleChange: (visible) => setPreviewOpen(visible),
              afterOpenChange: (visible) => !visible && setPreviewImage(""),
            }}
            src={previewImage}
          />
        )}
      </div>
    );
  };

  const handleImageError = () => {
    setProfileImageData(null);
  };

  const handleProfilePreview = () => {
    if (profileImageData) {
      setIsProfilePreviewVisible(true);
    }
  };

  return (
    <Form layout="vertical" autoComplete="off">
      {contextHolder}

      <Spin
        spinning={props.spinning || isLoading}
        style={{
          width: "32%",
        }}
      >
        <Card
          title={
            <>
              <Tooltip title={customerDetails.displayName}>
                {BOM.SubstringFormat(
                  customerDetails.displayName?.toUpperCase(),
                  25,
                )}
              </Tooltip>{" "}
              &nbsp;| {displayStatus}
            </>
          }
          hoverable
          bordered
        >
          <Row>
            <Col span={12}>
              <div style={{ width: 130, position: "relative" }}>
                <Space direction="vertical" size={16}>
                  <Space wrap size={16}>
                    {profileImageData ? (
                      <div style={{ position: "relative" }}>
                        <Avatar
                          size={64}
                          src={
                            typeof profileImageData === "object"
                              ? profileImageData.url
                              : profileImageData
                          }
                          onError={handleImageError}
                          style={{ cursor: "pointer" }}
                          onClick={handleProfilePreview}
                        />
                        {BOM.HasPermission("DELETE_CLIENTIMAGE") && (
                          <Button
                            type="default"
                            shape="circle"
                            icon={<DeleteOutlined />}
                            size="small"
                            style={{ position: "absolute", top: -8, right: -8 }}
                            onClick={handleDeleteProfileImage}
                          />
                        )}
                      </div>
                    ) : (
                      <Avatar size={64} icon={<UserOutlined />} />
                    )}
                    {BOM.HasPermission("CREATE_CLIENTIMAGE") && (
                      <Button
                        type="default"
                        shape="circle"
                        icon={<UploadOutlined />}
                        size="small"
                        style={{ position: "absolute", bottom: 0, right: 40 }}
                        onClick={showProfileModal}
                      />
                    )}
                  </Space>
                </Space>
              </div>
              <Divider orientation="left" orientationMargin="0">
                Signature Info{" "}
                {isShowSignature && (
                  <Tooltip title="Signature Setup">
                    <Button
                      type="primarys"
                      shape="circle"
                      icon={<EditOutlined />}
                      onClick={() => setOnEditShow(!onEditShow)}
                      disabled={!BOM.HasPermission("CREATE_DOCUMENT")}
                    />
                  </Tooltip>
                )}
                <Tooltip
                  title={`${isShowSignature ? "Hide" : "Show"} Signature`}
                >
                  <Button
                    type="primarys"
                    shape="circle"
                    icon={
                      isShowSignature ? (
                        <EyeInvisibleOutlined />
                      ) : (
                        <EyeOutlined />
                      )
                    }
                    disabled={!BOM.HasPermission("READ_DOCUMENT")}
                    onClick={() => setIsShowSignature(!isShowSignature)}
                  />
                </Tooltip>
              </Divider>
              {BOM.HasPermission("READ_DOCUMENT") &&
                renderUploadFram({
                  key: "signature",
                  name: "clientSignature",
                  description: "client signature",
                })}
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item label="Customer ID">
                <Input
                  value={customerDetails?.accountNo}
                  disabled
                  className="of-bold-disable-input"
                />
              </Form.Item>

              <Form.Item label="Branch Name">
                <Input
                  value={customerDetails?.officeName}
                  disabled
                  className="of-bold-disable-input"
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
      </Spin>

      {/* Profile Image Upload Modal - Upload Only */}
      <Modal
        title="Update Profile Image"
        open={isProfileModalVisible}
        onCancel={handleProfileModalCancel}
        footer={[
          <Button key="back" onClick={handleProfileModalCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={isLoading}
            onClick={handleProfileUpload}
            disabled={profileImageList.length === 0}
            style={{
              ...styles.ofPrimaryBtnColor,
            }}
          >
            Upload
          </Button>,
        ]}
      >
        <div
          style={{
            textAlign: "center",
            margin: "20px 0",
            border: "1px dashed #d9d9d9",
            padding: "20px",
            borderRadius: "8px",
          }}
        >
          <ImgCrop rotationSlider aspect={1}>
            <Upload {...profileUploadProps}>
              {profileImageList.length < 1 && (
                <div>
                  <UploadOutlined style={{ fontSize: 24, marginBottom: 8 }} />
                  <div>Click or drag image to upload</div>
                </div>
              )}
            </Upload>
          </ImgCrop>
        </div>

        <Text
          type="secondary"
          style={{ display: "block", marginTop: "20px", fontSize: 12 }}
        >
          Select an image file to update the profile picture. Maximum file size:
          2MB
        </Text>
      </Modal>

      {/* Profile Image Preview Modal */}
      <Image
        style={{ display: "none" }}
        preview={{
          visible: isProfilePreviewVisible,
          onVisibleChange: (visible) => setIsProfilePreviewVisible(visible),
          src:
            typeof profileImageData === "object"
              ? profileImageData?.url
              : profileImageData,
        }}
      />
    </Form>
  );
}

function renderStatistic(containerWidth, text) {
  const textStyleStr = `width:${containerWidth}px;font-size:15px;font-weight:400;line-height:2;`;
  return `<div style="${textStyleStr}">${text}</div>`;
}

const AssetPositionCard = () => {
  useEffect(() => {
    const data = [
      { type: "Investment", value: 27 },
      { type: "Fixed Asset", value: 25 },
      { type: "Current Assets", value: 18 },
      { type: "Cash", value: 15 },
      { type: "Inventory", value: 10 },
      { type: "Accounts Receivable", value: 5 },
    ];

    const containerWidth = "100%";
    const containerHeight = 200;

    const piePlot = new Pie("assetContainer", {
      appendPadding: 0,
      data,
      angleField: "value",
      colorField: "type",
      radius: 1,
      innerRadius: 0.64,
      width: containerWidth,
      height: containerHeight,
      meta: {
        value: {
          formatter: (v) => `${v} USD`,
        },
      },
      label: {
        type: "inner",
        offset: "-50%",
        style: {
          textAlign: "center",
        },
        autoRotate: false,
        content: "{value}",
      },
      statistic: {
        title: {
          offsetY: -4,
          customHtml: (container, view, datum) => {
            const d = Math.sqrt(
              Math.pow(containerWidth / 2, 2) +
                Math.pow(containerHeight / 2, 2),
            );
            const text = datum ? datum.type : "Total Assets";
            return renderStatistic(d, text);
          },
        },
        content: {
          offsetY: 4,
          style: {
            fontSize: "32px",
          },
          customHtml: (container, view, datum, data) => {
            const text = datum
              ? `USD ${datum.value}`
              : `USD ${data.reduce((r, d) => r + d.value, 0)}`;
            return renderStatistic(containerWidth, text);
          },
        },
      },
      interactions: [
        { type: "element-selected" },
        { type: "element-active" },
        { type: "pie-statistic-active" },
      ],
    });

    piePlot.render();

    return () => {
      piePlot.destroy();
    };
  }, []);

  return (
    <Card title={"Asset Position"} hoverable bordered>
      <div id="assetContainer" />
    </Card>
  );
};

const LiabilityPositionCard = () => {
  useEffect(() => {
    const data = [
      { type: "Investment", value: 27 },
      { type: "Fixed Asset", value: 25 },
      { type: "Current Assets", value: 18 },
      { type: "Cash", value: 15 },
      { type: "Inventory", value: 10 },
      { type: "Accounts Receivable", value: 5 },
    ];

    const containerWidth = "100%";
    const containerHeight = 200;

    const piePlot = new Pie("liabilityContainer", {
      appendPadding: 0,
      data,
      angleField: "value",
      colorField: "type",
      radius: 1,
      innerRadius: 0.64,
      width: containerWidth,
      height: containerHeight,
      meta: {
        value: {
          formatter: (v) => `${v} USD`,
        },
      },
      label: {
        type: "inner",
        offset: "-50%",
        style: {
          textAlign: "center",
        },
        autoRotate: false,
        content: "{value}",
      },
      statistic: {
        title: {
          offsetY: -4,
          customHtml: (container, view, datum) => {
            const d = Math.sqrt(
              Math.pow(containerWidth / 2, 2) +
                Math.pow(containerHeight / 2, 2),
            );
            const text = datum ? datum.type : "Total Liabilities";
            return renderStatistic(d, text);
          },
        },
        content: {
          offsetY: 4,
          style: {
            fontSize: "32px",
          },
          customHtml: (container, view, datum, data) => {
            const text = datum
              ? `USD ${datum.value}`
              : `USD ${data.reduce((r, d) => r + d.value, 0)}`;
            return renderStatistic(containerWidth, text);
          },
        },
      },
      interactions: [
        { type: "element-selected" },
        { type: "element-active" },
        { type: "pie-statistic-active" },
      ],
    });

    piePlot.render();

    return () => {
      piePlot.destroy();
    };
  }, []);

  return (
    <Card title={"Liability Position"} hoverable bordered>
      <div id="liabilityContainer" />
    </Card>
  );
};
